class ValueFormatters {
    public static trimExtraSpaces(value: string) {
        if (value) {
            return value.replace(/\s+/gi, ' ').trim();
        }

        return '';
    }

    public static toLowercase(value: string) {
        if (value) {
            return value.toLowerCase();
        }

        return '';
    }
}

export default ValueFormatters;
